<template>
    <rkm-modal
        ref="modal"
        title="Detalhes da solicitação"
        extraLarge
    >
        <modalSolicitacao
            :id="model.id"
            :pacienteId="model.pacienteId"
            :isVisualizacao="true"
            @close="() => this.$refs.modal.hide()"
        />
        <template v-slot:footer="{ cancel }">
            <rkm-button
                @click="cancel"
                color="secondary"
            >
                Fechar
            </rkm-button>
        </template>
    </rkm-modal>
</template>
<script>

// Components.
import modalSolicitacao from '@/components/regulacao/solicitacao/Form'

// Mixin.
import { repository } from '@/mixins'

export default {
    components: { modalSolicitacao },
    created() {
        this.repositories = {
            solicitacao: this.getConectaSusRepository('regulacao.solicitacao'),
        }
    },
    data: () => ({
        model: {
            id: null,
            pacienteId: null,
        },
    }),
    methods: {
        open(item) {
            this.model.pacienteId = item.pacienteId
            this.model.id = item.id
            this.$refs.modal.show()
        },
    },
    mixins: [ repository ],
}
</script>